export default "__VITE_ASSET__BlniCL$a__"